import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'lp-statistics-widget-header',
  templateUrl: './lp-statistics-widget-header.component.html',
  styleUrls: ['./lp-statistics-widget-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpStatisticsWidgetHeaderComponent {
  @Input() title = '';
}
